module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_05.png?fd3f3bff36386e7c5945c15bafacb129";